/** Textes « ui » — le français fait foi. */
export const ui = {
  appeler: (nom: string) => `Appeler ${nom}`,
  traceTitre: "Une opération n'a pas été enregistrée au journal",
  traceDebut: "L'opération elle-même a bien eu lieu, mais ",
  traceGras: "sa trace n'a pas pu être écrite",
  traceSuite: '. Les opérations suivantes sont bloquées tant que le journal ne répond pas.',
  tracePrevenez: ' Prévenez le gérant · finances',
  traceFin: " : il faut noter ce qui vient d'être fait avant de continuer.",
  horsLigne: 'Mode hors ligne — vos saisies seront synchronisées au retour du réseau',
  serveurTitre: 'Le serveur ne répond pas',
  serveurTexte: "Votre appareil est connecté, mais le logiciel n'arrive pas à joindre le serveur. Les écrans peuvent rester vides tant que la liaison n'est pas rétablie.",
  serveurRienPerdu: " Rien n'est perdu",
  serveurFin: ' : aucune de vos saisies enregistrées n\'est concernée.',
};
